import { useState, useCallback } from "react";

export function useEditorHistory(elements, bgColor, bgImage) {
  const [history, setHistory] = useState([]);

  const pushHistory = useCallback(() => {
    setHistory(prev => [...prev.slice(-30), JSON.stringify({ elements, bgColor, bgImage })]);
  }, [elements, bgColor, bgImage]);

  const undo = useCallback((setElements, setBgColor, setBgImage, setSelected) => {
    if (history.length === 0) return;
    const prev = JSON.parse(history[history.length - 1]);
    setHistory(h => h.slice(0, -1));
    setElements(prev.elements || []);
    setBgColor(prev.bgColor || "#f1f5f9");
    setBgImage(prev.bgImage || "");
    setSelected(null);
  }, [history]);

  return { history, pushHistory, undo };
}
